import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaUsers, FaHome, FaTree, FaEnvelope } from 'react-icons/fa';
import FullHouseQuoteModal from './FullHouseQuoteModal';
import ImageCarousel from './ImageCarousel';

const casaImages = [
  '/images/casa.webp',
  '/images/casa-1.jpeg',
  '/images/casa-2.jpeg',
  '/images/casa-3.jpeg',
  '/images/casa-4.jpeg',
];

const FullHouseCard = ({ index }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <motion.div
        whileHover={{ y: -8, transition: { duration: 0.3 } }}
        className="bg-white rounded-2xl overflow-hidden flex flex-col"
        style={{
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          transition: 'box-shadow 0.3s ease',
        }}
        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 20px 50px rgba(0, 0, 0, 0.15)'}
        onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)'}
      >
        <div className="relative">
          <ImageCarousel images={casaImages} />
          <div
            className="absolute top-3 right-3 text-white py-1.5 px-4 rounded-full font-bold z-10 text-sm"
            style={{
              background: 'rgba(196, 173, 121, 0.9)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              boxShadow: '0 4px 15px rgba(196, 173, 121, 0.3)',
            }}
          >
            ¡Exclusivo!
          </div>
        </div>
        <div className="p-6 flex flex-col flex-grow">
          <h3 className="text-2xl font-playfair font-bold text-gray-800 mb-2">Alquiler de Casa Completa</h3>
          <p className="text-gray-500 mb-5 flex-grow text-sm leading-relaxed">
            Disfruta de la privacidad y el espacio de toda nuestra Casa-Hotel. Ideal para grupos grandes, eventos familiares o retiros.
            Cotiza directamente con nuestro administrador para tarifas personalizadas y disponibilidad.
          </p>
          <div className="grid grid-cols-1 gap-y-2.5 mb-5">
            <div className="flex items-center text-gray-600 text-sm">
              <span className="text-teal-500 mr-2 text-base"><FaHome /></span>
              Privacidad total
            </div>
            <div className="flex items-center text-gray-600 text-sm">
              <span className="text-teal-500 mr-2 text-base"><FaUsers /></span>
              Ideal para grupos y familias
            </div>
            <div className="flex items-center text-gray-600 text-sm">
              <span className="text-teal-500 mr-2 text-base"><FaTree /></span>
              Uso exclusivo de instalaciones
            </div>
          </div>
        </div>
        <div className="px-6 pb-6">
          <motion.button
            onClick={() => setIsModalOpen(true)}
            whileHover={{ scale: 1.02, boxShadow: '0 10px 25px rgba(196, 173, 121, 0.3)' }}
            whileTap={{ scale: 0.98 }}
            className="w-full text-white py-3 px-6 text-sm font-semibold rounded-full transition-all duration-300 flex items-center justify-center"
            style={{ background: '#c4ad79' }}
          >
            <FaEnvelope className="mr-2" /> Cotizar Alquiler Completo
          </motion.button>
        </div>
      </motion.div>
      <FullHouseQuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FullHouseCard;
